import { Button, CircularProgress, Typography } from "@material-ui/core";
import AccessTimeFilledIcon from "@material-ui/icons/AccessTimeOutlined";
import ArrowBackIosNewIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import translate from "../../../i18n/translate";
import {
  createVocabularyNewWordList,
  getVocabularyContents,
  getVocabularySearchedWord,
  getVocabularyWordList,
} from "../../../redux/actions/vocabularyCenterAction";
import { LANGUAGE_ENGLISH, TRANSLATION } from "../VocabularyCenter/optionConstants";
import ReactTable, { getStandardHeaderView } from "./ReactTable";
import "./vocabularyPoc.scss";
import DialogView from "./DialogContents";
import SearchBar from "./SearchBar";
import InfoDetails from "./InfoDetails";
import { NON_CASE_SENSITIVE, USER } from "../../../redux/constants";

const VocabularyCenter = () => {
  const WORDLIST_REGEX = /^[ A-Za-z0-9()-.;:?!&]*$/;
  const dispatch = useDispatch();
  const [searchText, setSearchText] = React.useState<string>("");
  const [isCalled, setIsCalled] = React.useState<boolean>(false);
  const [topicLevelDetails, setTopicLevelDetails] = React.useState<any>([]);
  const { peopleInformation, common, vocabularyContents } = useSelector((state: any) => state);
  const [showWordLists, setShowWordLists] = React.useState<boolean>(false);
  const [wordListDetails, setWordListDetails] = React.useState<any>([]);
  const [showWords, setShowWords] = React.useState<boolean>(false);
  const [infoDetails, setInfoDetails] = React.useState<any>({});
  const [showingWordListDetails, setShowingWordListDetails] = React.useState<any>({});
  const [showAddWordList, setShowAddWordList] = React.useState<boolean>(false);
  const [newWordList, setNewWordList] = React.useState<any>("");
  const [showInfoDetails, setShowInfoDetails] = React.useState<boolean>(false);
  const [alreadyExistsMessage, setAlreadyExistsMessage] = React.useState<boolean>(false);
  const [showError, setShowError] = React.useState<boolean>(false);

  React.useEffect(() => {
    const peopleInfoStateValidation = peopleInformation ? peopleInformation.data : "";
    if (peopleInfoStateValidation !== null && common && common.lgId !== "" && !isCalled) {
      setIsCalled(true);
      dispatch(
        getVocabularyContents(
          common.lgId,
          peopleInfoStateValidation.getpeopleInformation.token,
          parseInt(peopleInfoStateValidation.getpeopleInformation.accountId, 10)
        )
      );
    }
  }, [peopleInformation, common]);

  React.useEffect(() => {
    const localTopicLevelDetails: any = [];
    if (
      vocabularyContents &&
      vocabularyContents.headerLevelContents &&
      typeof vocabularyContents.headerLevelContents === "object" &&
      Object.keys(vocabularyContents.headerLevelContents).length > 0
    ) {
      const topicLevelReduxDetails = vocabularyContents.headerLevelContents;
      const commonTopics = topicLevelReduxDetails["Common"];
      const organizationTopics = topicLevelReduxDetails["Organization"];
      const userTopics = topicLevelReduxDetails["User"];
      if (Object.keys(commonTopics).length > 0) {
        Object.keys(commonTopics).forEach((topic: any) => {
          if (topic !== "totalWordlistCount" && commonTopics[topic]) {
            localTopicLevelDetails.push({
              headerTitle: removeSpecialCharacters(topic),
              listDetails: commonTopics[topic],
              listLength: commonTopics[topic].length,
              isUserWordList: false,
            });
          }
        });
      }
      if (organizationTopics && Object.keys(organizationTopics).length > 0) {
        Object.keys(organizationTopics).forEach((organizationTopic: any) => {
          if (organizationTopic !== "totalWordlistCount" && organizationTopics[organizationTopic]) {
            localTopicLevelDetails.push({
              headerTitle: removeSpecialCharacters(organizationTopic),
              listDetails: commonTopics[organizationTopic],
              listLength: commonTopics[organizationTopic].length,
              isUserWordList: false,
            });
          }
        });
      }
      localTopicLevelDetails.push({
        headerTitle: "My word lists",
        listDetails: userTopics.userWordlists ?? [],
        listLength: userTopics.userWordlists ? userTopics.userWordlists.length : 0,
        isUserWordList: true,
      });
      const topicParam = getParameterByName("topic");
      const idParam = getParameterByName("id");
      const filteredTopicArray = localTopicLevelDetails
        .slice()
        .filter((topicDetails: any) => topicDetails.headerTitle === topicParam);
      if (topicParam !== null) {
        setWordListDetails(filteredTopicArray[0] ?? {});
        setShowWordLists(true);
      }
      // if (topicParam !== "" && idParam !== null) {
      //   const finalListDetails = filteredTopicArray[0]
      //     ? filteredTopicArray[0].listDetails.slice().filter((listDetail: any) => listDetail.listId === idParam)
      //     : {};
      // }
      setTopicLevelDetails(localTopicLevelDetails);
    }
  }, [vocabularyContents]);

  React.useEffect(() => {
    if (infoDetails && Object.keys(infoDetails).length > 0) {
      setShowInfoDetails(true);
    }
  }, [infoDetails]);

  const removeSpecialCharacters = (providedWord: any) => {
    switch (providedWord) {
      case "Industry_Word_Lists":
        return "Industry word lists";
      case "Topic_Word_Lists":
        return "Topic word lists";
      default:
        return "Learnship + users word lists";
    }
  };

  const getWordListDetails = (listDetails: any) => {
    addUrlParams("id", listDetails.listId);
    setShowingWordListDetails(listDetails);
    dispatch(
      getVocabularyWordList(
        common.lgId,
        peopleInformation.data.getpeopleInformation.token,
        listDetails.listId,
        TRANSLATION,
        LANGUAGE_ENGLISH
      )
    );
    setShowWords(true);
  };

  const getAddWordList = () => {
    return (
      <>
        {getStandardHeaderView(translate("vocab_center_add_wordlist"), () => {
          setShowAddWordList(false);
          setNewWordList("");
        })}
        <div className="add-view-contents-box">
          <Typography className="add-view-edit-label">{translate("vocab_center_new_wordlist")}:</Typography>
          <input
            type="text"
            className="word-list-input"
            value={newWordList}
            onChange={(e) => {
              setShowError(!WORDLIST_REGEX.test(e.target.value));
              setNewWordList(e.target.value);
              setAlreadyExistsMessage(false);
            }}
            maxLength={40}
          />
        </div>
        {showError && <p className="show-error-message">Please enter a-z,A-Z,0-9,()-.,;:?!&</p>}
        {alreadyExistsMessage && (
          <div className="already-exists-container">
            <AccessTimeFilledIcon className="history-icon" />
            <p className="already-exists-label">{translate("vocab_center_word_exists_in_wordlist_warning_message")}.</p>
          </div>
        )}
        <div className="word-list-action-box">
          <Button
            variant="contained"
            className="word-list-action-button"
            onClick={handleWordListActions}
            disabled={
              alreadyExistsMessage ||
              vocabularyContents.isWordListCreating ||
              vocabularyContents.isWordListUpdating ||
              newWordList.length === 0 ||
              showError
            }
          >
            {vocabularyContents.isWordListUpdating || vocabularyContents.isWordListCreating ? (
              <CircularProgress size="20" />
            ) : (
              translate("vocab_center_save_text")
            )}
          </Button>
          <Button
            variant="contained"
            className="word-list-action-button"
            onClick={() => {
              setShowAddWordList(false);
              setNewWordList("");
            }}
          >
            {translate("vocab_center_close_text")}
          </Button>
        </div>
      </>
    );
  };

  const handleWordListActions = () => {
    const userWordList = topicLevelDetails.filter(
      (topicLevelDetail: any) => topicLevelDetail.headerTitle === "My word lists"
    );
    const isExists =
      userWordList[0] && userWordList[0].listDetails
        ? userWordList[0].listDetails.findIndex((listDetails: any) => listDetails.wordlist === newWordList)
        : -1;
    if (isExists !== -1) {
      setAlreadyExistsMessage(true);
    } else {
      dispatch(createVocabularyNewWordList(peopleInformation.data.getpeopleInformation.token, newWordList, USER));
      setTimeout(() => {
        setShowAddWordList(false);
      }, 2000);
    }
  };

  const handleSearch = (e: any) => {
    if (
      (e && e.key && e.key.toUpperCase() === "ENTER" && searchText.length > 0) ||
      (e && e.target && e.target.id === "search-button" && searchText.length > 0)
    ) {
      dispatch(
        getVocabularySearchedWord(
          common.lgId,
          peopleInformation.data.getpeopleInformation.token,
          searchText,
          USER,
          NON_CASE_SENSITIVE
        )
      );
      setInfoDetails(undefined);
      setShowInfoDetails(true);
    }
  };

  const getSearchedWordDetails = () => {
    if (infoDetails && Object.keys(infoDetails).length > 0) {
      return infoDetails;
    }
  };

  const addUrlParams = (title: any, param: any) => {
    if (window.history.state) {
      let searchParams = new URLSearchParams(window.location.search);
      searchParams.set(title, param);
      let newUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?" +
        searchParams.toString();
      window.history.pushState({ path: newUrl }, "", newUrl);
    }
  };

  const deleteUrlParams = (key: any) => {
    var uri = window.location.toString();
    var clean_uri = uri.substring(0, uri.indexOf(key));
    window.history.replaceState({}, document.title, clean_uri);
  };

  const getParameterByName = (key: any) => {
    const match = RegExp("[?&]" + key + "=([^&]*)").exec(window.location.search);
    const result = match && decodeURIComponent(match[1].replace(/\+/g, " "));
    return result;
  };

  return (
    <div className="new-vocabulary-center-container-wrapper">
      <div className="new-vocabulary-center-container">
        {!vocabularyContents.isLoading ||
          (!vocabularyContents.isSubTopicLoading && (
            <div className="loader-vocab-center">
              <CircularProgress color="primary" className="circularLoader" size={100} />
            </div>
          ))}
        <Typography className="product-headline-title">{translate("vocab_center_product_headline")}</Typography>
        <div className={`vocabulary-center-headline-box ${showWordLists ? "hide-box" : ""}`}>
          <Typography className="product-highlighter">{translate("vocab_center_feature_text")}</Typography>
        </div>
        <SearchBar
          searchText={searchText}
          setSearchText={setSearchText}
          changeClassName={`${showWordLists ? "change-view" : ""}`}
          handleSearch={handleSearch}
        />
        {!showWordLists && (
          <>
            <div className="vocabulary-center-topic-level-details">
              {topicLevelDetails.length === 0 ? (
                <div className="loader-wrapper">
                  <CircularProgress color="primary" className="circularLoader" size={100} />
                </div>
              ) : (
                topicLevelDetails.map((topicLevelDetail: any, index: number) => (
                  <div
                    className={`topic-level-card ${topicLevelDetail.headerTitle}`}
                    key={`${index}`}
                    onClick={() => {
                      addUrlParams("topic", topicLevelDetail.headerTitle);
                      setWordListDetails(topicLevelDetail);
                      setShowWordLists(true);
                    }}
                  >
                    <div className={`topic-level-card-content`}>
                      <Typography gutterBottom variant="h5" component="div" className={`topic-level-card-title`}>
                        {topicLevelDetail.headerTitle}
                      </Typography>
                      <Typography variant="body2" className={`topic-level-card-details`}>
                        {topicLevelDetail.listLength} Word lists
                      </Typography>
                    </div>
                  </div>
                ))
              )}
            </div>
          </>
        )}
        {showWordLists && !showWords && (
          <div className="vocabulary-center-wordlist-container">
            {vocabularyContents.isWordAddingToList ||
            vocabularyContents.isWordListCreating ||
            vocabularyContents.isWordDeleting ||
            vocabularyContents.isWordListDeleting ? (
              <div className="loader-wrapper">
                <CircularProgress color="primary" className="circularLoader" size={100} />
              </div>
            ) : (
              <>
                <div className="back-container">
                  <div
                    className="back-container-wrapper"
                    onClick={() => {
                      deleteUrlParams("?");
                      setWordListDetails([]);
                      setShowWordLists(false);
                    }}
                  >
                    <ArrowBackIosNewIcon className="back-icon" />
                    <p className="back-label">Back</p>
                  </div>
                  {wordListDetails.isUserWordList && (
                    <div className="add-wordlist-box">
                      <div className="add-wordlist-box-wrapper" onClick={() => setShowAddWordList(true)}>
                        <AddCircleIcon className="add-wordlist-icon" />
                        <p className="add-wordlist-label">Add wordlist</p>
                      </div>
                    </div>
                  )}
                </div>
                <div className="topic-list-details-container">
                  {wordListDetails && wordListDetails.listDetails && wordListDetails.listDetails.length > 0 ? (
                    wordListDetails.listDetails.map((listDetail: any, subIndex: number) => (
                      <div
                        className="topic-list-details"
                        key={`${subIndex}`}
                        onClick={() => {
                          getWordListDetails(listDetail);
                        }}
                      >
                        <p className="topic-list-label">
                          {listDetail.wordlist} ({listDetail.wordCount})
                        </p>
                        <ArrowForwardIosIcon className="topic-list-arrow-action" />
                      </div>
                    ))
                  ) : (
                    <div className="no-wordlist-container">
                      <p className="no-wordlist-message">
                        {translate("vocab_center_no_wordlist_message", { wordListName: wordListDetails.headerTitle })}
                      </p>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        )}
        {showWords && (
          <div className="word-list-container">
            <ReactTable
              setInfoDetails={setInfoDetails}
              isUserWordList={wordListDetails.isUserWordList}
              showingWordListDetails={showingWordListDetails}
              setShowWords={setShowWords}
              changeView={() => {
                deleteUrlParams("&");
                setShowWords(false);
              }}
            />
          </div>
        )}
        <DialogView
          open={showAddWordList}
          handleClose={() => setShowAddWordList(false)}
          dialogContainerClassNameValue="vocabulary-show-add-wordlist-popup"
          dialogContentsClassName="vocabulary-show-add-wordlist-contents"
          dialogBody={getAddWordList()}
        />
        <DialogView
          open={showInfoDetails}
          handleClose={() => {
            setShowInfoDetails(false);
            setSearchText("");
            setInfoDetails({});
          }}
          dialogContainerClassNameValue="vocabulary-show-info-details-popup"
          dialogContentsClassName="vocabulary-show-info-details-contents"
          dialogBody={
            <InfoDetails
              handleClose={() => {
                setShowInfoDetails(false);
                setSearchText("");
                setInfoDetails({});
              }}
              infoDetails={getSearchedWordDetails()}
              newWordTitle={searchText}
              setShowAddWordList={setShowAddWordList}
            />
          }
        />
      </div>
    </div>
  );
};

export default VocabularyCenter;
